import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path } from '../IconBase/IconBase'

function Plus({ color = 'icon.primary', strokeWidth = '1.5', ...props }) {
  return (
    <IconBase viewBox='0 0 20 20' {...props}>
      <Path
        d='M10.0019 13.6809L10.0019 6.3125'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M13.6875 9.99807L6.31908 9.99807'
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Plus.propTypes = {
  color: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default Plus
